import React from 'react';
import { ViewExperienceTrackingProvider } from '@atlassian/jira-common-experience-tracking-viewing/src/view/experience-tracking-provider/index.tsx';
import ReportErrors from '@atlassian/jira-errors-handling/src/utils/reporting-error-boundary.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { isPlanEmbed } from '@atlassian/jira-portfolio-3-common/src/embed/index.tsx';
import { isPollinatorTenant } from '@atlassian/jira-portfolio-3-common/src/feature-flags/index.tsx';
import type { State } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/types.tsx';
import {
	ERROR_REPORTING_PACKAGE,
	ERROR_REPORTING_TEAM,
	PACKAGE_NAME,
} from '@atlassian/jira-portfolio-3-portfolio/src/common/view/constant.tsx';
import withViewExperienceTracker, {
	type InjectedProps,
} from '@atlassian/jira-portfolio-3-portfolio/src/common/view/experience-tracking/with-view-experience-tracker/index.tsx';
import {
	ContextualAnalyticsData,
	FireScreenAnalytics,
	SCREEN,
} from '@atlassian/jira-product-analytics-bridge';
import { connect } from '@atlassian/jira-react-redux/src/index.tsx';
import { JIRA_PORTFOLIO } from '@atlassian/jira-shared-types/src/application.tsx';
import { useAppEditions } from '@atlassian/jira-tenant-context-controller/src/components/app-editions/index.tsx';
import mapDispatchToProps from './command.tsx';
import mapStateToProps from './query.tsx';
import type { StateProps, DispatchProps, OwnProps } from './types.tsx';
import View from './view.tsx';

const Connected = withViewExperienceTracker(
	connect<StateProps, DispatchProps, OwnProps & InjectedProps, State>(
		mapStateToProps,
		mapDispatchToProps,
	)(View),
	'portfolio-3.simple-plans.dependencies.dependencies-view',
);

const WrappedDependenciesTab = (props: OwnProps) => {
	const { software: edition } = useAppEditions();
	return (
		<ViewExperienceTrackingProvider
			experience="viewPortfolio3Dependencies"
			analyticsSource="portfolio3"
			application={JIRA_PORTFOLIO}
			edition={edition}
			additionalAttributes={{
				synthetic: isPollinatorTenant(),
				...(fg('smart_links_for_plans') ? { isEmbed: isPlanEmbed() } : {}),
			}}
		>
			<ContextualAnalyticsData
				sourceType={SCREEN}
				sourceName={ERROR_REPORTING_PACKAGE.DEPENDENCIES}
			>
				<FireScreenAnalytics attributes={{}} />
				<ReportErrors
					id={ERROR_REPORTING_PACKAGE.DEPENDENCIES}
					packageName={PACKAGE_NAME}
					teamName={ERROR_REPORTING_TEAM}
					sendToPrivacyUnsafeSplunk
				>
					<Connected {...props} />
				</ReportErrors>
			</ContextualAnalyticsData>
		</ViewExperienceTrackingProvider>
	);
};

export default WrappedDependenciesTab;
